import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from '@models/Core/User';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@services/auth/authentication.service';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { SearchService } from '@services/search.service';

import { DirectMsgComponent } from '../account/direct-msg/direct-msg.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent {
  query: string;
  ideas: Idea[];
  sessions: Session[];
  people: User[];
  me: any;
  showing: 'ideas' | 'topics' | 'people' = 'ideas';
  compact = true;

  constructor(
    private route: ActivatedRoute,
    private search: SearchService,
    private auth: AuthenticationService,
    private bus: BusService,
    private events: EventsService,
    private modal: NgbModal,
  ) {
    this.auth.getCurrentUser.subscribe(me => {
      this.me = me;

      this.route.queryParams.subscribe(params => {
        if (params.q) {
          this.query = params.q;
        }

        this.search.search(this.query).subscribe((response: any) => {
          this.ideas = [];
          this.sessions = [];
          this.people = [];

          response.topics.forEach(entry => {
            entry.topic.me = entry.topic.config.participants.find(
              participant => participant.user_id === this.me._id,
            );
            entry.topic.i_follow = !!entry.topic.data.followers.find(
              follower => follower.participant_id === entry.topic.me._id,
            );
            entry.topic.$match = entry.match;
            entry.topic.data.followers = entry.topic.data.followers.length;
            this.sessions.push(entry.topic);
          });

          response.ideas.forEach(entry => {
            const session = response.ideaTopics[entry.session];
            entry.idea.session = session;
            entry.idea.$match = entry.match;

            if (session && !session.me) {
              session.me = session.config.participants.find(
                participant => participant.user_id === this.me._id,
              );
            }

            if (session && session.me) {
              this.ideas.push(entry.idea);
            }
          });

          response.users.forEach(entry => {
            entry.user.$match = entry.match;
            this.people.push(entry.user);
          });

          if (this.ideas.length !== 0) {
            this.showing = 'ideas';
          } else if (this.sessions.length !== 0) {
            this.showing = 'topics';
          } else if (this.people.length !== 0) {
            this.showing = 'people';
          } else {
            this.showing = 'ideas';
          }
        });
      });
    });
  }

  openIdea(idea: Idea, session: Session) {
    this.bus.publish(
      this.events.requested.data.session.idea.singleWithSession,
      idea._id,
      session._id,
    );
  }

  directMsg(user, event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const ref = this.modal.open(DirectMsgComponent);
    ref.componentInstance.user = user;
  }
}
